export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Consulting',
  hero_title_ja: 'AIX Consulting',
  hero_desc: 'From AI strategy formulation to DX promotion and new AI business launch, we support every phase of corporate transformation.',
  overview_label: 'OVERVIEW',
  overview_title: 'Service Overview',
  overview_desc: 'AIX Consulting is a total consulting service that realizes corporate transformation and sustainable growth by combining AI with every business domain (X).\n\nWe support end-to-end, from management-level AI utilization strategy design to on-site adoption, not just tool implementation. Dedicated consultants accompany you through all phases from upstream strategy planning to downstream execution support, ensuring tangible results.',
  services_label: 'SERVICES',
  services_title: 'Main Service Areas',
  service_1_title: 'AI Strategy Formulation',
  service_1_desc: 'Analyzing your business challenges, competitive environment, and data assets to design optimal AI utilization strategies. We consistently formulate short-term to long-term roadmaps.',
  service_2_title: 'DX Promotion Support',
  service_2_desc: 'From visualizing business workflows to selecting and implementing AI and digital tools, experienced consultants provide end-to-end support for DX rooted in your operations.',
  service_3_title: 'New AI Business Launch',
  service_3_desc: 'Supporting planning, validation, and launch of new businesses utilizing AI across all phases, from market research to PoC design and commercialization.',
  service_4_title: 'ROI Maximization Support',
  service_4_desc: 'Visualizing AI investment effectiveness and building continuous improvement cycles. We establish mechanisms to maximize ROI, from KPI design to effectiveness measurement and improvement.',
  challenges_label: 'CHALLENGES',
  challenges_title: 'We Solve These Challenges',
  challenge_1: 'Unable to formulate an AI strategy, do not know where to start',
  challenge_2: 'DX promotion is stalled and has become superficial',
  challenge_3: 'Feel that AI utilization is lagging behind competitors',
  challenge_4: 'Considering AI implementation but ROI is unclear',
  challenge_5: 'Exploring new business expansion by combining AI with existing operations',
  challenge_6: 'Difficult to involve both management and on-site staff in transformation',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'Why Companies Choose AIX JAPAN',
  reason_1_title: 'End-to-End from Management to On-site',
  reason_1_desc: 'The same team takes responsibility for supporting all phases from strategy formulation to on-site adoption. Seamless accompaniment produces reliable results.',
  reason_2_title: 'Rich Cross-industry Knowledge',
  reason_2_desc: 'Based on track records across diverse industries such as manufacturing, finance, retail, and healthcare, we design optimal AI utilization strategies unconstrained by industry conventions.',
  reason_3_title: 'Commitment to Results',
  reason_3_desc: 'From KPI design to effectiveness measurement, our culture of demonstrating results in numbers is our strength. We focus on "producing results," not just "implementing."',
  reason_4_title: 'Dedicated Team Accompaniment Model',
  reason_4_desc: 'We assemble dedicated teams for each project, providing close accompaniment tailored to each client. We value long-term partnerships.',
  flow_label: 'FLOW',
  flow_title: 'Implementation Flow',
  flow_intro: 'From the first consultation to continuous improvement, we clarify the work and deliverables of each step. Durations vary by project scope and are indicative only.',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-chat-3-line',
      title: 'Current State Interview & Issue Mapping',
      note: 'Free',
      duration: 'approx. 1-2 weeks',
      activities: [
        'Interviews covering business challenges, workflows, data assets, and existing systems',
        'Initial hypotheses on where AI can help — it is fine if you do not yet know where to start',
      ],
      deliverables: ['Issue summary', 'Candidate list of AI themes'],
      clientAsks: ['Interview time with key members (1-2 hours, a few sessions)', 'Sharing of existing materials (workflows, org chart, etc.)'],
    },
    {
      no: '02',
      icon: 'ri-compass-3-line',
      title: 'AI Strategy & Roadmap Design',
      duration: 'approx. 2-4 weeks',
      activities: [
        'Prioritization of themes and ROI estimation',
        'Short- and mid-term roadmap design with an executive briefing',
      ],
      deliverables: ['AI strategy document', 'Implementation roadmap', 'Rough ROI estimate'],
      clientAsks: ['Participation in the executive review', 'Decision on priorities'],
    },
    {
      no: '03',
      icon: 'ri-flask-line',
      title: 'PoC & Execution Support',
      duration: 'approx. 1-3 months',
      activities: [
        'Design and execution of a small-scale PoC with measured accuracy and impact',
        'Tool/vendor selection support and on-site adoption support',
      ],
      deliverables: ['PoC report (based on measured results)', 'Inputs for the go/no-go decision'],
      clientAsks: ['Provision of test data and samples', 'Participation of frontline members in testing'],
    },
    {
      no: '04',
      icon: 'ri-line-chart-line',
      title: 'Measurement & Continuous Improvement',
      duration: 'Ongoing (monthly)',
      activities: [
        'KPI-based verification and an operating improvement cycle',
        'Design of the next themes and internalization support',
      ],
      deliverables: ['Monthly report', 'Improvement and expansion proposals'],
      clientAsks: ['Participation in a monthly review meeting'],
    },
  ],
};